// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@flip/App/Components/Common/XngZone";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

export interface invoiceDetailsPagesLayout {
    logo?: InjectableCss;
}

export const invoiceDetailsPagesLayout: invoiceDetailsPagesLayout = {
    logo: {
        css: css`
            a {
                display: none;
            }
            @media print {
                margin: 20px 0;
                a {
                    display: block;
                }
            }
        `,
    },
};

const styles = invoiceDetailsPagesLayout;
const InvoiceDetailsPagesLayout: FC<any> = ({ id, fields }) => {
    return (
        <StyledWrapper data-test-selector="My-Account-Details-Pages-Layout">
            <StyledWrapper {...styles.logo}>
                <XngZone contentId={id} zoneName="Logo" hint="Zone for Logo (print mode)" />
            </StyledWrapper>
            <StyledWrapper>
                <XngZone contentId={id} zoneName="Content01" hint="Zone For header" />
            </StyledWrapper>

            <StyledWrapper>
                <XngZone contentId={id} zoneName="Content02" hint="Zone For details" />
            </StyledWrapper>
            <StyledWrapper>
                <XngZone contentId={id} zoneName="Content03" hint="Zone For summary table" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: InvoiceDetailsPagesLayout,
    definition: {
        group: "Layout" as any,
        displayName: "Invoice Details Pages Layout",
    },
};

export default widgetModule;
